import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Button, Card, Col, ListGroup, Row, Spinner } from "react-bootstrap";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import {
  getFileLiveUrl,
  groupByMultiple,
  LOADER_LOGO,
  makeUrl,
  momentDate,
  NO_IMAGE_LOGO_WIDE,
  upperCase,
} from "../../utils";
import { Link } from "react-router-dom";

import "react-accessible-accordion/dist/fancy-example.css";
import { Image } from "antd";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";

const ViewEvent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataAllList, setAllList] = useState([]);
  const [eventYear, setEventYear] = useState([]);
  const [eventData, setEventData] = useState({});
  const [content, setContent] = useState("null");
  const [eventImages, setEventImages] = useState([]);

  useEffect(() => {
    loadData();
    listData();
  }, [props.match.params]);

  useEffect(() => {
    loadImages();
  }, [content, props.match.params]);
  useEffect(() => {
    listEventYear();
    listEventData();
  }, []);

  const listEventYear = () => {
    axios.get(ServiceUrl.GET_YEAR + "?type=event").then((res) => {
      if (res["data"].status == "1") {
        setEventYear(res["data"].data);
      }
    });
  };

  const listEventData = async () => {
    try {
      const res = await axios.get(`${ServiceUrl.GET_EVENT}?type=event`);
      if (res.data.status === "1") {
        setEventData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching event data", error);
    }
    return;
  };

  const getEvent = (y) => {
    return (
      eventData &&
      eventData.length > 0 &&
      eventData
        .filter((item) => momentDate(item.active_from_date, "YYYY") == y)
        .map((item) => (
          <Link to={`/event/${item.id}/${makeUrl(item.title)}`}>
            <p
              key={item.id}
              style={{ fontSize: "15px" }}
              className="text_theme"
            >
              <i className="fas fa-angle-right mx-2"></i> {item.title}{" "}
              <span className="text-danger">
                {momentDate(item.active_from_date, "MMM-DD")}
              </span>
            </p>
          </Link>
        ))
    );
  };

  const loadImages = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.GET_IMAGES + "?type=eventgallery&content=" + content)
      .then((res) => {
        if (res["data"].status == "1") {
          setEventImages(res["data"].data);
        }
        setLoader(false);
      });
  };

  const loadData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.GET_PAGE + "?type=event&id=" + props.match.params.id)
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setContent(res["data"].data.content);
        }
        setLoader(false);
      });
  };

  const listData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=event&id=" + props.match.params.id)
      .then((res) => {
        if (res["data"].status == "1") {
          setAllList(res["data"].data);
        }
        setLoader(false);
      });
  };
  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}

      {!loader && dataList.id && (
        <>
          <SuperSEO title={"Events " + field("title")} lang="en" />

          <section>
            <div className="head-2">
              <div className="container">
                <div className="head-2-inn head-2-inn-padd-top">
                  <h1>Event</h1>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
              <Row>
                <Col md={8}>
                  <Row style={{ fontFamily: "-moz-initial" }}>
                    <h5 className="text_theme">{upperCase(field("title"))}</h5>
                    <div className="text-danger">
                      {momentDate(field("active_from_date"))}
                    </div>
                    {eventImages &&
                      eventImages.length > 0 &&
                      eventImages.map((item, i) => {
                        return (
                          <>
                            <Col md={4} className="mt-2">
                              <Image
                                height="200px"
                                key={i}
                                src={getFileLiveUrl(item.feature_image)}
                                alt="First slide"
                                placeholder={
                                  item && (
                                    <div
                                      style={{ height: "calc(100vh - 250px" }}
                                    >
                                      <center className="mt-5">
                                        <Spinner
                                          animation="border"
                                          role="status"
                                        ></Spinner>
                                      </center>
                                    </div>
                                  )
                                }
                              />
                            </Col>
                          </>
                        );
                      })}
                  </Row>
                </Col>
                {eventImages.length < 1 && (
                  <Col md={8}>
                    <div className="ho-event pg-eve-main pg-blog">
                      <Image
                        className="w-100 mt-3 rounded"
                        src={getFileLiveUrl(field("feature_image"))}
                        alt="event"
                        placeholder={
                          field("feature_image") && (
                            <div style={{ height: "calc(100vh - 250px" }}>
                              <center className="mt-5">
                                <Spinner
                                  animation="border"
                                  role="status"
                                ></Spinner>
                              </center>
                            </div>
                          )
                        }
                      />

                      <div
                        dangerouslySetInnerHTML={{
                          __html: field("content_html"),
                        }}
                      />
                    </div>
                  </Col>
                )}
                <Col md={4} style={{ fontFamily: "-moz-initial" }}>
                  <div style={{ border: "1px solid #011a41" }}>
                    <Link to="/events/completed">
                      <h6
                        style={{
                          textDecoration: "underline",
                        }}
                        className="text-center text_theme mt-2"
                      >
                        View All Events
                      </h6>
                    </Link>
                  </div>
                  <div>
                    {eventYear.length > 0 &&
                      eventYear.map((item, i) => (
                        <Accordion allowZeroExpanded key={i}>
                          <AccordionItem>
                            <AccordionItemHeading className="bg-primary">
                              <AccordionItemButton>
                                {momentDate(item.active_from_date, "YYYY")}
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              {getEvent(
                                momentDate(item.active_from_date, "YYYY")
                              )}
                            </AccordionItemPanel>
                          </AccordionItem>
                        </Accordion>
                      ))}
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default ViewEvent;
